import { Action, createReducer, on } from '@ngrx/store';
import { IAnagraphicState } from './anagraphic';
import {
  EDIT_THIRD_NETWORK_DETAIL_SUCCESS,
  RETRIEVE_ADD_ANAGRAPHIC_SUCCESS,
  RETRIEVE_ANAGRAPHIC_SUCCESS,
  RETRIEVE_DOCUMENTS_SUCCESS,
  RETRIEVE_INTERFACE_MONITORING_SUCCESS,
  RETRIEVE_CRMO_DETAIL_SUCCESS,
  RETRIEVE_RISOTTOMETTI_CRMO_ERROR,
  RETRIEVE_RISOTTOMETTI_DASHBOARD_ERROR,
  RETRIEVE_OPERATION_HISTORY_SUCCESS,
  RETRIEVE_THIRD_NETWORK_DETAIL_SUCCESS,
  SET_CURRENT_SIGLA_RETE,
  RETRIEVE_SAP_DETAIL_SUCCESS,
  RETRIEVE_RISOTTOMETTI_SAP_ERROR,
  RETRIEVE_INTERFACE_HISTORY_CRM_SUCCESS,
  RETRIEVE_OPERATION_PROGRESSIVE_SUCCESS,
  UPLOAD_FILE_NEW_OPERATION_SUCCESS,
  RETRIEVE_MAL_SUCCESS,
  RETRIEVE_RAM_SUCCESS,
  RETRIEVE_CD_SUCCESS,
  RETRIEVE_POINTS_LIST_SUCCESS,
  CHANGE_STATUS_SUCCESS,
  UPLOAD_FILE_MASSIVE_ACTIVATION_SUCCESS,
  CONFIRM_FILE_MASSIVE_ACTIVATION_SUCCESS,
  RETRIEVE_GESTIONE_PUNTOPOSTE_SUCCESS,
  RETRIEVE_CMP_LIST_SUCCESS,
  RETRIEVE_CP_SUCCESS,
  RETRIEVE_REPORT_GIACENZE_LIST_SUCCESS,
  RETRIEVE_INTERFACE_HISTORY_SAP_SUCCESS,
  RETRIEVE_INTERFACE_HISTORY_DASHBOARD_SUCCESS,
  RESET_ANAGRAPHIC_STORE,
  RETRIEVE_REPORT_GIACENZE_LOCKER_LIST_SUCCESS,
  RETRIEVE_DASHBOARD_DETAIL_SUCCESS,
  RETRIEVE_STORICO_ICON,
  RETRIEVE_STORICO_ICON_SUCCESS,
  CHANGE_STATUS_PPS_SUCCESS,
  UPLOAD_FILE_PREACTIVATION_SUCCESS,
  CONFIRM_FILE_PREACTIVATION_SUCCESS,
  CHECK_ATTIVAZIONE_SERVIZI_FORZATA_SUCCESS,
  ATTIVAZIONE_FORZATA_SERVIZI_SUCCESS,
  ATTIVAZIONE_FORZATA_SERVIZI_FAILURE,
  UPLOAD_FILE_FORCE_MASSIVE_ACTIVATION_SERVICE_SUCCESS,
  CONFIRM_FILE_FORCE_MASSIVE_SERVICE_ACTIVATION_SUCCESS,
  UPLOAD_FILE_CARICAMENTO_MASSIVO_FERIE_SUCCESS,
  CONFIRM_CARICAMENTO_FILE_MASSIVO_FERIE_SUCCESS,
  UPLOAD_FILE_CARICAMENTO_MASSIVO_GESTIONE_UTENZE_SUCCESS,
  CONFIRM_CARICAMENTO_FILE_MASSIVO_GESTIONE_UTENZE_SUCCESS,
} from './anagraphic.actions';
import {
  ResponseAggiuntaAnagrafica,
  ResponseAnagraphicManagement,
} from '../../interfaces/response-anagraphic-management';
import { ResponseReteTerzaDettaglio } from '../../interfaces/response-rete-terza-dettaglio';
import { ResponseInterfaceMonitoringSap } from '../../interfaces/response-interface-monitoring-sap';
import { ResponseInterfaceMonitoringCrm } from '../../interfaces/response-interface-monitoring-crm';
import { ResponseDocuments } from '../../interfaces/response-documents';
import {
  ResponseCRMO,
  ResponseDashboard,
  ResponseSAP,
} from '../../interfaces/response-monitoring-interface';
import { ResponseStoricoOperazioni } from '../../interfaces/response-operation-history';
import { ResponseInterfaceHistoryCrm } from '../../interfaces/response-interface-history-crm';
import { ResponseOperazioniProgressivo } from '../../interfaces/response-operation-progressive';
import {
  IResponseCd,
  IResponseMal,
  IResponseRam,
} from '../../interfaces/mal-ram-cd';
import {
  IPayloadCambioStato,
  IResponseCambioStato,
  IResponseCambioStatoPps,
  IResponseListaGestionePunti,
} from '../../interfaces/points-management';
import {
  IResponseConfermaCaricamentoAttivazioneMassiva,
  IResponseUploadAttivazioneMassiva,
} from '../../interfaces/attivazione-massiva';
import { RetrieveGestionPuntoPoste } from '../../interfaces/retrieve-gestione-puntoposte';
import { ResponseCMP, ResponseCP } from '../../interfaces/puntoposte-detail';
import { IResponseReportGiacenzeList } from '../../interfaces/report-giacenze';
import { IResponseStoricoSap } from '../../interfaces/response-interface-history-sap';
import { ResponseInterfaceMonitoringDashboard } from '../../interfaces/response-interface-monitoring-dashboard';
import { IResponseReportGiacenzeLockerList } from '../../interfaces/report-giacenze-locker';
import { IResponseStoricoDashboard } from '../../interfaces/response-interface-history-dashboard';
import { IResponseStoricoIcon } from '../../interfaces/monitoraggio-storico-icon';
import {
  IResponseConfermaCaricamentoPreAttivazione,
  IResponseUploadPreAttivazione,
} from '../../interfaces/forzatura-preattivazione';

/* INITIAL STATE */
const initialState: IAnagraphicState = {
  responseAnagrafica: null,
  responseAggiuntaAnagrafica: null,
  responseModificaReteTerzaDettaglio: null,
  responseInterfaceMonitoring: null,
  responseDocuments: null,
  responseStoricoOperazioni: undefined,
  responseStoricoSap: undefined,
  responseOperazioniProgressivo: undefined,
  responseNuovaOperazioneFile: undefined,
  responseMal: undefined,
  responseRam: undefined,
  responseReportGiacenzeList: undefined,
  responseListaGestionePunti: null,
  responsePuntoPoste: null,
  responseCP: null,
  responseReportGiacenzeLockerList: null,
  responseDashboard: null,
  responseCambioStatoWithPayload: null,
  responseCambioStatoPpsWithPayload: null,
  responseStoricoIcon: null,
  attivazioneForzataServiziSuccessMessage: null,
  attivazioneForzataServiziErrorMessage: null,
};

const handleResponseAnagraphic = (
  state: IAnagraphicState,
  { responseAnagrafica }: { responseAnagrafica: ResponseAnagraphicManagement }
): IAnagraphicState => {
  return {
    ...state,
    responseAnagrafica,
  };
};

const handleResponseAddAnagraphic = (
  state: IAnagraphicState,
  {
    responseAggiuntaAnagrafica,
  }: { responseAggiuntaAnagrafica: ResponseAggiuntaAnagrafica }
): IAnagraphicState => {
  return {
    ...state,
    responseAggiuntaAnagrafica,
  };
};

const handleSetCurrentSiglaRete = (
  state: IAnagraphicState,
  { currentSiglaRete }: { currentSiglaRete: string | null }
): IAnagraphicState => {
  return {
    ...state,
    currentSiglaRete,
  };
};

const handleResponseThirdNetworkDetail = (
  state: IAnagraphicState,
  {
    responseReteTerzaDettaglio,
  }: { responseReteTerzaDettaglio: ResponseReteTerzaDettaglio }
): IAnagraphicState => {
  return {
    ...state,
    responseReteTerzaDettaglio,
  };
};

const handleResponseEditThirdNetwork = (
  state: IAnagraphicState,
  {
    responseModificaReteTerzaDettaglio,
  }: { responseModificaReteTerzaDettaglio: ResponseAggiuntaAnagrafica | null }
): IAnagraphicState => {
  return {
    ...state,
    responseModificaReteTerzaDettaglio,
  };
};

const handleResponseInterfaceMonitoring = (
  state: IAnagraphicState,
  {
    responseInterfaceMonitoring,
  }: {
    responseInterfaceMonitoring:
      | ResponseInterfaceMonitoringCrm
      | ResponseInterfaceMonitoringSap
      | ResponseInterfaceMonitoringDashboard
      | null;
  }
): IAnagraphicState => {
  return {
    ...state,
    responseInterfaceMonitoring,
  };
};
const handleResponseResponseDocuments = (
  state: IAnagraphicState,
  { responseDocuments }: { responseDocuments: ResponseDocuments | null }
): IAnagraphicState => {
  return {
    ...state,
    responseDocuments,
  };
};

const handleResponseCrmoDetail = (
  state: IAnagraphicState,
  { responseCrmo }: { responseCrmo: ResponseCRMO | null }
): IAnagraphicState => {
  return {
    ...state,
    responseCrmo,
  };
};

const handleRespondeRisottomettiCrm = (
  state: IAnagraphicState,
  { responseRisottomettiCrm }: { responseRisottomettiCrm: ResponseCRMO }
): IAnagraphicState => {
  return {
    ...state,
    responseRisottomettiCrm,
  };
};

const handleRespondeRisottomettiDashboard = (
  state: IAnagraphicState,
  {
    responseRisottomettiDashboard,
  }: { responseRisottomettiDashboard: ResponseDashboard | null }
): IAnagraphicState => {
  return {
    ...state,
    responseRisottomettiDashboard,
  };
};

const handleResponseOperationHistory = (
  state: IAnagraphicState,
  {
    responseStoricoOperazioni,
  }: { responseStoricoOperazioni: ResponseStoricoOperazioni | null }
): IAnagraphicState => {
  return {
    ...state,
    responseStoricoOperazioni,
  };
};

const handleResponseSapDetail = (
  state: IAnagraphicState,
  { responseSap }: { responseSap: ResponseSAP | null }
): IAnagraphicState => {
  return {
    ...state,
    responseSap,
  };
};

const handleResponseDashboardDetail = (
  state: IAnagraphicState,
  { responseDashboard }: { responseDashboard: ResponseDashboard | null }
): IAnagraphicState => {
  return {
    ...state,
    responseDashboard,
  };
};

const handleRespondeRisottomettiSap = (
  state: IAnagraphicState,
  { responseRisottomettiSap }: { responseRisottomettiSap: ResponseSAP }
): IAnagraphicState => {
  return {
    ...state,
    responseRisottomettiSap,
  };
};

const handleResponseOperationProgressive = (
  state: IAnagraphicState,
  {
    responseOperazioniProgressivo,
  }: { responseOperazioniProgressivo: ResponseOperazioniProgressivo | null }
): IAnagraphicState => {
  return {
    ...state,
    responseOperazioniProgressivo,
  };
};

const handleResponseInterfaceHistory = (
  state: IAnagraphicState,
  {
    responseInterfaceHistory,
  }: { responseInterfaceHistory: ResponseInterfaceHistoryCrm | null }
): IAnagraphicState => {
  return {
    ...state,
    responseInterfaceHistory,
  };
};

const handleResponseInterfaceHistorySap = (
  state: IAnagraphicState,
  { responseStoricoSap }: { responseStoricoSap: IResponseStoricoSap | null }
): IAnagraphicState => {
  return {
    ...state,
    responseStoricoSap,
  };
};

const handleResponseInterfaceHistoryDashboard = (
  state: IAnagraphicState,
  {
    responseStoricoDashboard,
  }: { responseStoricoDashboard: IResponseStoricoDashboard | null }
): IAnagraphicState => {
  return {
    ...state,
    responseStoricoDashboard,
  };
};

const handleResponseNewOperationFile = (
  state: IAnagraphicState,
  { responseNuovaOperazioneFile }: { responseNuovaOperazioneFile: any }
): IAnagraphicState => {
  return {
    ...state,
    responseNuovaOperazioneFile,
  };
};

const handleResponseMal = (
  state: IAnagraphicState,
  { responseMal }: { responseMal: IResponseMal }
): IAnagraphicState => {
  return {
    ...state,
    responseMal,
  };
};

const handleResponseRam = (
  state: IAnagraphicState,
  { responseRam }: { responseRam: IResponseRam }
): IAnagraphicState => {
  return {
    ...state,
    responseRam,
  };
};

const handleResponseCd = (
  state: IAnagraphicState,
  { responseCd }: { responseCd: IResponseCd }
): IAnagraphicState => {
  return {
    ...state,
    responseCd,
  };
};

const handleResponseListaGestionePunti = (
  state: IAnagraphicState,
  {
    responseListaGestionePunti,
  }: { responseListaGestionePunti: IResponseListaGestionePunti | null }
): IAnagraphicState => {
  return {
    ...state,
    responseListaGestionePunti,
  };
};

const handleResponseCambioStato = (
  state: IAnagraphicState,
  {
    responseCambioStatoWithPayload,
  }: {
    responseCambioStatoWithPayload: {
      responseCambioStato: IResponseCambioStato;
      payload: IPayloadCambioStato;
    } | null;
  }
): IAnagraphicState => {
  return {
    ...state,
    responseCambioStatoWithPayload,
  };
};

const handleResponseCambioStatoPPS = (
  state: IAnagraphicState,
  {
    responseCambioStatoPpsWithPayload,
  }: {
    responseCambioStatoPpsWithPayload: {
      responseCambioStato: IResponseCambioStatoPps;
      payload: IPayloadCambioStato;
    } | null;
  }
): IAnagraphicState => {
  return {
    ...state,
    responseCambioStatoPpsWithPayload,
  };
};

const handleResponseMassiveActivationFile = (
  state: IAnagraphicState,
  {
    responseAttivazioneMassivaFile,
  }: {
    responseAttivazioneMassivaFile: IResponseUploadAttivazioneMassiva | null;
  }
): IAnagraphicState => {
  return {
    ...state,
    responseAttivazioneMassivaFile,
  };
};

const handleResponseConfirmMassiveActivationFile = (
  state: IAnagraphicState,
  {
    responseConfermaAttivazioneMassivaFile,
  }: {
    responseConfermaAttivazioneMassivaFile: IResponseConfermaCaricamentoAttivazioneMassiva;
  }
): IAnagraphicState => {
  return {
    ...state,
    responseConfermaAttivazioneMassivaFile,
  };
};

const handleResponsePreAttivazioneFile = (
  state: IAnagraphicState,
  {
    responsePreAttivazioneFile,
  }: {
    responsePreAttivazioneFile: IResponseUploadPreAttivazione | null;
  }
): IAnagraphicState => {
  return {
    ...state,
    responsePreAttivazioneFile,
  };
};

const handleResponseConfirmPreAttivazioneFile = (
  state: IAnagraphicState,
  {
    responseConfermaPreAttivazioneFile,
  }: {
    responseConfermaPreAttivazioneFile: IResponseConfermaCaricamentoPreAttivazione;
  }
): IAnagraphicState => {
  return {
    ...state,
    responseConfermaPreAttivazioneFile,
  };
};

const handleResponsePuntoPoste = (
  state: IAnagraphicState,
  {
    responsePuntoPoste,
  }: { responsePuntoPoste: RetrieveGestionPuntoPoste | null }
): IAnagraphicState => {
  return {
    ...state,
    responsePuntoPoste,
  };
};

const handleResponseCMPList = (
  state: IAnagraphicState,
  { responseCMP }: { responseCMP: ResponseCMP }
): IAnagraphicState => {
  return {
    ...state,
    responseCMP,
  };
};

const handleResponseCP = (
  state: IAnagraphicState,
  { responseCP }: { responseCP: ResponseCP | null }
): IAnagraphicState => {
  return {
    ...state,
    responseCP,
  };
};

const handleResponseAudit = (
  state: IAnagraphicState,
  { responseAudit }: { responseAudit: any }
): IAnagraphicState => {
  return {
    ...state,
    responseAudit,
  };
};

const handleRetrieveReportGiacenzeList = (
  state: IAnagraphicState,
  {
    responseReportGiacenzeList,
  }: { responseReportGiacenzeList?: IResponseReportGiacenzeList }
): IAnagraphicState => {
  return {
    ...state,
    responseReportGiacenzeList,
  };
};

const handleRetrieveReportGiacenzeLockerList = (
  state: IAnagraphicState,
  {
    responseReportGiacenzeLockerList,
  }: {
    responseReportGiacenzeLockerList: IResponseReportGiacenzeLockerList | null;
  }
): IAnagraphicState => {
  return {
    ...state,
    responseReportGiacenzeLockerList,
  };
};

const handleMonitoraggioStoricoIcon = (
  state: IAnagraphicState,
  { responseStoricoIcon }: { responseStoricoIcon?: IResponseStoricoIcon | null }
): IAnagraphicState => {
  return {
    ...state,
    responseStoricoIcon,
  };
};

const handleResetAnagraphicStore = (): IAnagraphicState => {
  return {
    ...initialState,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(RETRIEVE_ANAGRAPHIC_SUCCESS, handleResponseAnagraphic),
  on(RETRIEVE_ADD_ANAGRAPHIC_SUCCESS, handleResponseAddAnagraphic), // aggiunta anagrafica success
  on(RETRIEVE_THIRD_NETWORK_DETAIL_SUCCESS, handleResponseThirdNetworkDetail),
  on(RETRIEVE_INTERFACE_MONITORING_SUCCESS, handleResponseInterfaceMonitoring),
  on(EDIT_THIRD_NETWORK_DETAIL_SUCCESS, handleResponseEditThirdNetwork),
  on(RETRIEVE_DOCUMENTS_SUCCESS, handleResponseResponseDocuments),
  on(SET_CURRENT_SIGLA_RETE, handleSetCurrentSiglaRete),
  on(RETRIEVE_OPERATION_HISTORY_SUCCESS, handleResponseOperationHistory),
  on(RETRIEVE_CRMO_DETAIL_SUCCESS, handleResponseCrmoDetail),
  on(RETRIEVE_RISOTTOMETTI_CRMO_ERROR, handleRespondeRisottomettiCrm),
  on(
    RETRIEVE_RISOTTOMETTI_DASHBOARD_ERROR,
    handleRespondeRisottomettiDashboard
  ),
  on(RETRIEVE_SAP_DETAIL_SUCCESS, handleResponseSapDetail),
  on(RETRIEVE_RISOTTOMETTI_SAP_ERROR, handleRespondeRisottomettiSap),
  on(RETRIEVE_INTERFACE_HISTORY_CRM_SUCCESS, handleResponseInterfaceHistory),
  on(RETRIEVE_INTERFACE_HISTORY_SAP_SUCCESS, handleResponseInterfaceHistorySap),
  on(
    RETRIEVE_INTERFACE_HISTORY_DASHBOARD_SUCCESS,
    handleResponseInterfaceHistoryDashboard
  ),
  on(
    RETRIEVE_OPERATION_PROGRESSIVE_SUCCESS,
    handleResponseOperationProgressive
  ),
  on(UPLOAD_FILE_NEW_OPERATION_SUCCESS, handleResponseNewOperationFile),
  on(RETRIEVE_MAL_SUCCESS, handleResponseMal),
  on(RETRIEVE_RAM_SUCCESS, handleResponseRam),
  on(RETRIEVE_CD_SUCCESS, handleResponseCd),
  on(RETRIEVE_POINTS_LIST_SUCCESS, handleResponseListaGestionePunti),
  on(CHANGE_STATUS_SUCCESS, handleResponseCambioStato),
  on(CHANGE_STATUS_PPS_SUCCESS, handleResponseCambioStatoPPS),
  on(
    UPLOAD_FILE_MASSIVE_ACTIVATION_SUCCESS,
    handleResponseMassiveActivationFile
  ),
  on(
    CONFIRM_FILE_MASSIVE_ACTIVATION_SUCCESS,
    handleResponseConfirmMassiveActivationFile
  ),
  on(UPLOAD_FILE_PREACTIVATION_SUCCESS, handleResponsePreAttivazioneFile),
  on(
    CONFIRM_FILE_PREACTIVATION_SUCCESS,
    handleResponseConfirmPreAttivazioneFile
  ),
  on(RETRIEVE_GESTIONE_PUNTOPOSTE_SUCCESS, handleResponsePuntoPoste),
  on(RETRIEVE_CMP_LIST_SUCCESS, handleResponseCMPList),
  on(RETRIEVE_CP_SUCCESS, handleResponseCP),
  on(RETRIEVE_REPORT_GIACENZE_LIST_SUCCESS, handleRetrieveReportGiacenzeList),
  on(
    RETRIEVE_REPORT_GIACENZE_LOCKER_LIST_SUCCESS,
    handleRetrieveReportGiacenzeLockerList
  ),
  on(RESET_ANAGRAPHIC_STORE, handleResetAnagraphicStore),
  on(RETRIEVE_DASHBOARD_DETAIL_SUCCESS, handleResponseDashboardDetail),
  on(RESET_ANAGRAPHIC_STORE, handleResetAnagraphicStore),
  on(RETRIEVE_STORICO_ICON_SUCCESS, handleMonitoraggioStoricoIcon),

  //Attivazione forzata servizi
  on(CHECK_ATTIVAZIONE_SERVIZI_FORZATA_SUCCESS, (state, { stato }) => ({
    ...state,
    statoAttivazioneForzataServizi: stato,
  })),
  on(ATTIVAZIONE_FORZATA_SERVIZI_SUCCESS, (state) => ({
    ...state,
    attivazioneForzataServiziSuccessMessage:
      'Attivazione forzata del servizio per il punto poste completata con successo',
    attivazioneForzataServiziErrorMessage: null,
  })),
  on(ATTIVAZIONE_FORZATA_SERVIZI_FAILURE, (state) => ({
    ...state,
    attivazioneForzataServiziSuccessMessage: null,
    attivazioneForzataServiziErrorMessage:
      'Errore durante attivazione forzata del servizio del punto poste',
  })),
  on(
    UPLOAD_FILE_FORCE_MASSIVE_ACTIVATION_SERVICE_SUCCESS,
    (state, { responseForzaAttivazioneServiziMassivaFile }) => ({
      ...state,
      responseForzaAttivazioneServiziMassivaFile,
    })
  ),
  on(
    CONFIRM_FILE_FORCE_MASSIVE_SERVICE_ACTIVATION_SUCCESS,
    (state, { responseConfermaAttivazioneForzataServiziMassivaFile }) => ({
      ...state,
      responseConfermaAttivazioneMassivaFile:
        responseConfermaAttivazioneForzataServiziMassivaFile,
    })
  ),
  on(
    UPLOAD_FILE_CARICAMENTO_MASSIVO_FERIE_SUCCESS,
    (state, { responseUploadFerieFile }) => ({
      ...state,
      responseUploadMassivoFerieFile: responseUploadFerieFile, // <-- aggiorna lo stato!
    })
  ),
  on(
    CONFIRM_CARICAMENTO_FILE_MASSIVO_FERIE_SUCCESS,
    (state, { responseConfermaCaricamentoMassivoFileFerie }) => ({
      ...state,
      responseConfermaCaricamentoMassivoFileFerie:
        responseConfermaCaricamentoMassivoFileFerie,
    })
  ),
  on(
    UPLOAD_FILE_CARICAMENTO_MASSIVO_GESTIONE_UTENZE_SUCCESS,
    (state, { responseUploadGestioneUtenzeFile }) => ({
      ...state,
      responseUploadMassivoGestioneUtenzeFile: responseUploadGestioneUtenzeFile, // <-- aggiorna lo stato!
    })
  ),
  on(
    CONFIRM_CARICAMENTO_FILE_MASSIVO_GESTIONE_UTENZE_SUCCESS,
    (state, { responseConfermaCaricamentoMassivoFileGestioneUtenze }) => ({
      ...state,
      responseConfermaCaricamentoMassivoFileGestioneUtenze:
        responseConfermaCaricamentoMassivoFileGestioneUtenze,
    })
  )
);

export const anagraphicReducer = (
  state: IAnagraphicState | undefined,
  action: Action
): IAnagraphicState => reducer(state, action);
